import { useState, useEffect } from 'react';
import Alerts from "./alerts"
import Map from "./map"
import { kinds } from "./sensorstatus"

export default function Contents(props) {
  const [position, setPosition] = useState([props.map.latitude, props.map.longitude]);
  const [kind, setKind] = useState(kinds[0]);
  const [point, setPoint] = useState(null);
  const [points, setPoints] = useState([]);

  useEffect(() => {
    if (props.points) setPoints(props.points);
  }, []);

  useEffect(() => {
    setSelectedKind(kind)
  }, [kind]);

  useEffect(() => {
    setSelectedKind(kind)
  }, [props.points]);

  function changeListPoint(name) {
    setPosition(null)
    const res = props.points.find((p) => p.name === name)
    setPoint(res)
    window.location.hash = name;
  }

  function changeMapPoint(name) {
    setPosition(null)
    const res = props.points.find((p) => p.name === name)
    setPoint(res)
  }

  function changeCenter(name) {
    const res = props.points.find((p) => p.name === name)
    if (res) setPosition([res.latitude, res.longitude])
  }

  function setSelectedKind(akind) {
    var apoints = props.points.concat();
    for (var p of apoints) {
      if (akind.name === "気温") {
        p.selected = p.temp;
      } if (akind.name === "湿度") {
        p.selected = p.humi;
      } if (akind.name === "風速") {
        p.selected = p.wind;
      } if (akind.name === "雨量") {
        p.selected = p.rain;
      } if (akind.name === "震度") {
        p.selected = p.seis;
      } if (akind.name === "雷") {
        p.selected = p.thunder;
      }
    }
    setPoints(apoints);
  }

  function changeKind(argkind = "") {
    for (var i = 0; i < kinds.length; i++) {
      if (kinds[i].name === argkind) {
        setSelectedKind(kinds[i]);//これがないとタブ通りにならない
        setKind(kinds[i]);
        break;
      }
    }
  }

  return (
    <main>
      <div style={{ position: "absolute", zIndex: -1 }}>
        <Map position={position} points={points} onSelect={changeListPoint} point={point} onOpenSite={props.setsite} />
        <div style={{ position: "absolute", top: 8, right: 8, zIndex: 1000  }}>
          <Alerts kind={kind} points={points} onSelect={changeMapPoint} onMove={changeCenter} changeKind={changeKind} point={point} onOpenSite={props.setsite} />
        </div>
      </div>
    </main>
  )
}
